import { useState } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Hook para manejar tags del lead
 * @param {Object} detallesLead - Detalles del lead actual
 * @param {Function} setDetallesLead - Actualiza detalles del lead
 * @param {Array} contactos - Lista de contactos
 * @param {Function} setContactos - Actualiza contactos
 * @param {Array} lista3LeadsLiberados - Leads liberados
 * @param {Function} GuardarComentario - Guarda comentarios
 * @param {Function} guardarNotificacion - Guarda notificaciones
 * @param {Function} crearObjAction - Crea objeto de acción
 * @returns {Object} Estados y funciones para gestión de tags
 */
export const useLeadTags = (detallesLead, setDetallesLead, contactos, setContactos, lista3LeadsLiberados, GuardarComentario, guardarNotificacion, crearObjAction) => {
    const { token, setToken, idUsuario, nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [Modal_BitAddTag, setModal_BitAddTag] = useState(false);
    const [Modal_JsonTags, setModal_JsonTags] = useState([]);
    const [Modal_valueTagSelected, setModal_valueTagSelected] = useState(-1);
    const [TagsForModalDDL, SetTagsForModalDDL] = useState([]);

    const actualizarJsonTags = async (updatedTags, objDDLTag, tags) => {
        var jDataSend = {
            vJsonTags: updatedTags,
            idLead: detallesLead.idLead
        };

        const response = await fetch("/api/leads/actualizarJsonTags/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                GuardarComentario("Modificó el tag <b>" + objDDLTag.vNombreTag + "</b>", "2", detallesLead.idLead);

                var detalles = JSON.parse(data.detalles);

                if (contactos !== null && typeof contactos !== 'undefined') {
                    var currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                    if (currentLeadIndex == -1) {
                        var detalleslead_Copy = detallesLead;
                        detalleslead_Copy.vJsonTags = data.detalles;
                        detalleslead_Copy.ObjJsonTags = detalles;
                        setContactos([detalleslead_Copy, ...contactos]);
                    } else {
                        contactos[currentLeadIndex].iDaysDiff = 0;
                        contactos[currentLeadIndex].vJsonTags = data.detalles;
                        contactos[currentLeadIndex].ObjJsonTags = detalles;
                    }
                }

                if (lista3LeadsLiberados !== null && lista3LeadsLiberados !== undefined) {
                    var currentLeadLiberado = lista3LeadsLiberados.findIndex((l) => l.idLead == detallesLead.idLead);
                    if (currentLeadLiberado > -1) {
                        lista3LeadsLiberados[currentLeadLiberado].vJsonTags = data.detalles;
                    }
                }

                if (idUsuario != detallesLead.idUsuario) {
                    var objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                    guardarNotificacion("Cambio de etiqueta de Lead",
                        "<b> " + nombreCompleto + "</b> ha cambiado las etiquetas del lead <b>#" + detallesLead.idLead + "</b> : <i> '" + objDDLTag.vNombreTag.substring(0, 5) + "...'</i>",
                        detallesLead.idUsuario,
                        objToActionString,
                        2
                    );
                }

                setDetallesLead({
                    ...detallesLead,
                    vJsonTags: data.detalles,
                    ObjJsonTags: detalles
                });

                setModal_JsonTags(detalles);

                var TagsToSelect_Copy = [];
                tags.map(function (a) {
                    let matched = detalles.filter(b => a.idLeadTag === b.idLeadTag);
                    if (!matched.length) {
                        TagsToSelect_Copy.push(a);
                    }
                });

                SetTagsForModalDDL(TagsToSelect_Copy);
                showSuccessToast("Tag " + objDDLTag.vNombreTag + " modificado");
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    return {
        Modal_BitAddTag,
        setModal_BitAddTag,
        Modal_JsonTags,
        setModal_JsonTags,
        Modal_valueTagSelected,
        setModal_valueTagSelected,
        TagsForModalDDL,
        SetTagsForModalDDL,
        actualizarJsonTags
    };
};
